import { momentToString } from '@shared/innmaxLib/utils/webHelper'
import React from 'react'
import {
  FeedbackStatusColorEnum,
  useFeedbackStatusEnumText,
} from './feedback.enum'

export const useConvertFeedback = () => {
  const { enumToText } = useFeedbackStatusEnumText()

  const converter = React.useCallback((data: any) => {
    if (!data) {
      return null
    }

    return {
      ...data,
      createAtStr: data.createAt ? momentToString(data.createAt) : null,
      statusStr: enumToText(data.status),
      statusColor: FeedbackStatusColorEnum[data.status],
    }
  }, [])

  return {
    converter,
  }
}
